import React, { Fragment } from 'react'
import filterStyles from '../filters.scss'
import styles from './SetPrivacyMenu.scss'
import { RadioGroup } from 'common/styleguide/RadioGroup'
import { Msg, privacyLevels } from 'lib/localization'
import { OrderedMap } from 'immutable'
import { injectIntl, defineMessages } from 'react-intl'

export const setPrivacyMenuMessages = defineMessages({
  setPrivacy: {
    id: 'SetPrivacyMenu.setPrivacy',
    defaultMessage: 'Set Privacy'
  }
})

class _SetPrivacyMenu extends React.PureComponent {
  state = {
    selected: null
  }

  render () {
    const { onApply, intl } = this.props
    const { selected } = this.state

    return (
      <Fragment>
        <RadioGroup
          options={OrderedMap({
            '0': intl.formatMessage(privacyLevels.public),
            '1': intl.formatMessage(privacyLevels.private),
            '2': intl.formatMessage(privacyLevels.friendsOnly)
          })}
          selected={selected}
          onChange={(value) => this.setState({ selected: value })}
          radioClass={styles.radioClass}
          horizontal={false}
        />
        <a className={filterStyles.apply} onClick={() => onApply(selected)}><Msg m={setPrivacyMenuMessages.setPrivacy} /></a>
      </Fragment>
    )
  }
}

export const SetPrivacyMenu = injectIntl(_SetPrivacyMenu)
